import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getFanPurchasedLiveEventsRpcContract = rpcContract({
  name: "get-fan-purchased-live-events",
  paramsSchema: v.object({
    limit: v.optional(v.pipe(v.number(), v.minValue(1), v.maxValue(50)), 10),
    offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  }),
  resultSchema: v.object({
    events: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        content_tier: v.string(),
        fee_cents: v.nullable(v.number()),
        status: v.string(),
        scheduled_start_time: v.string(),
        actual_start_time: v.nullable(v.string()),
        end_time: v.nullable(v.string()),
        thumbnail_url: v.nullable(v.string()),
        thumbnail_path: v.nullable(v.string()),
        post_buying_video_url: v.nullable(v.string()),
        whatsapp_url: v.nullable(v.string()),
        cta_text: v.nullable(v.string()),
        influencer_id: v.string(),
        influencer_handle: v.nullable(v.string()),
        influencer_display_name: v.nullable(v.string()),
        influencer_avatar: v.nullable(v.string()),
        purchased_at: v.string(),
      }),
    ),
    totalCount: v.number(),
    hasMore: v.boolean(),
  }),
});

export type GetFanPurchasedLiveEventsParams = v.InferOutput<
  (typeof getFanPurchasedLiveEventsRpcContract)["paramsSchema"]
>;
export type GetFanPurchasedLiveEventsResult = v.InferOutput<
  (typeof getFanPurchasedLiveEventsRpcContract)["resultSchema"]
>;
export type FanPurchasedLiveEvent = v.InferOutput<
  (typeof getFanPurchasedLiveEventsRpcContract)["resultSchema"]
>["events"][0];
